import React, {useEffect, useState} from 'react';
import SignIn from "./SignIn/SignIn";
import {motion} from 'framer-motion';
import s from "./LoginizationSteps.module.css"
import AutenticationStep from "./AutenticationStep/AutenticationStep";
import {NavLink, useLocation} from "react-router-dom";
import quest from "../../assets/images/common/quest.svg";
import ForgotPassword from "../../components/ForgotPassword/ForgotPassword";
import TwoFa from "../../components/Autentications/TwoFa/TwoFa";
import CustomModalContactContainer from "../../components/ui/CustomModalContactContainer/CustomModalContactContainer";
import brandConfig, { brandTheme } from '../../config/config';
import worldVector from "../../assets/images/registerPage/world.svg";
import NewPassword from '../../components/NewPassword/NewPassword';
import {Helmet} from "react-helmet-async";

type PropsType = {
    currentStep?: number | undefined
}

const LoginizationSteps = (props: PropsType) => {

    useEffect(() => {
        localStorage.clear()
        localStorage.removeItem('persist:root')
    }, [])

    const location = useLocation();
    const searchString = location.search;
    // const resetToken = searchString.replace("?resetToken=", "");


    const [current, setCurrent] = useState(!props.currentStep ? 0 : props.currentStep);
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [additionalSettings, setAdditionalSettings] = useState({})
    const [dataForSend, setDataForSend] = useState({
        email: '',
        password: '',
        emailCode: '',
        twoFaCode: '',
        smsCode: ''
    })

    // useEffect(() => {
    //     if (resetToken) {
    //         setCurrent(4);
    //     }
    // }, [resetToken]);

    const steps = [
        {
            content: <SignIn setCurrent={setCurrent}
                             current={current}
                             setLoginData={setDataForSend}
                             dataForSend={dataForSend}
                             setAdditionalSettings={setAdditionalSettings}
            />
        },
        {
            content: <AutenticationStep setCurrent={setCurrent} dataForSend={dataForSend}
                                        setDataForSend={setDataForSend} additionalSettings={additionalSettings}/>
        },
        {
            content: <ForgotPassword setCurrent={setCurrent}/>
        },
        {
            content: <TwoFa
                setDataForSend={setDataForSend}
                dataForSend={dataForSend}
            />
        },
        {
            content: <NewPassword setCurrent={setCurrent}  />
        },
    ];

    return (
        <motion.div
            initial={{opacity: 0, scale: 1}}
            animate={{opacity: 1, scale: 1}}
            transition={{duration: 0.5}}
        >
            <Helmet>
                <title>Sign In | Access Your Fortres BanCorp Banking Account</title>
                <meta name="description" content="Securely sign in to your Fortres account to manage payments, track transactions, and access digital banking services." />
                <meta name="keywords" content="online banking login, secure banking login, fintech account access" />
            </Helmet>
            <CustomModalContactContainer isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen}/>

            <div className={s.wrapper}>

                <div className={s.login_wrapper_content_left}>
                    {/* <div className={s.left_content}>
                        <div className={s.left_content_title}>{brandConfig.companyNameSimple}</div>
                    </div> */}
                    <div className={s.logo_block}>
                        <NavLink to={"/"}>
                            <img src={brandTheme.brandIcon} alt={brandTheme.brandLogoAlt} width={brandTheme.brandLogoWidth} height={brandTheme.brandLogoHeight} />
                            <h1 className={s.welcome_title}>Welcome to Fortres Bank!</h1>
                            <h3 className={s.sub_content}>Building your future, together</h3>
                        </NavLink>
                    </div>
                </div>
                <div className={s.login_wrapper_content_right}>
                    <div className={s.quest_block}>
                        <img src={quest} alt="" onClick={() => setIsModalOpen(true)}/>
                    </div>
                    <div>{steps[current].content}</div>
                </div>
            </div>
        </motion.div>
    );
};

export default LoginizationSteps;